"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const web_sdk_1 = tslib_1.__importDefault(require("@samknows/web-sdk"));
const Emitter_1 = require("./Emitter");
const InstantTest_const_1 = require("./InstantTest.const");
var WebSpeedTestErrors;
(function (WebSpeedTestErrors) {
    WebSpeedTestErrors["DURATION_TOO_SHORT"] = "DURATION_TOO_SHORT";
    WebSpeedTestErrors["OTHER_ERROR"] = "OTHER_ERROR";
    WebSpeedTestErrors["WEB_TEST_NOT_INITIATED"] = "WEB_TEST_NOT_INITIATED";
})(WebSpeedTestErrors || (WebSpeedTestErrors = {}));
const DeviceTesting = Object.assign(Object.assign(Object.assign({}, Emitter_1.emitter), Emitter_1.internalEmitter), { webSpeedTest: null, webTestConfig: {}, init(config) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.webSpeedTest = this.initWebSpeedTest(config);
            this.webSpeedTest.on('error', (error) => {
                console.error('error', error);
                const errorStatus = WebSpeedTestErrors[error.message] ||
                    WebSpeedTestErrors.OTHER_ERROR;
                Emitter_1.emitter.emit('error', errorStatus);
                Emitter_1.internalEmitter.emit('instant-test:close-ws');
            });
            this.webSpeedTest.on('progress', (results) => {
                this.handleTest(InstantTest_const_1.TestStatus.IN_PROGRESS, results, results.inProgress // We need to cast across so that this will be seen as an enum rather than a string type, but they're the same
                );
            });
            this.webSpeedTest.on('test-done', (test, results) => {
                this.handleTest(InstantTest_const_1.TestStatus.FINISHED, results, test // We need to cast across so that this will be seen as an enum rather than a string type, but they're the same
                );
                Emitter_1.internalEmitter.emit('instant-test:test-finished');
            });
        });
    },
    initWebSpeedTest(config) {
        this.webTestConfig = {
            global: {
                testServers: config.testServer ? [config.testServer] : undefined,
                targetSet: config.targetSet
            }
        };
        return new web_sdk_1.default(this.webTestConfig);
    },
    runWebSpeedTest(test, options = {}) {
        if (!this.webSpeedTest) {
            Emitter_1.emitter.emit('error', WebSpeedTestErrors.WEB_TEST_NOT_INITIATED);
            return;
        }
        this.webSpeedTest.run(test, options);
    },
    handleTest(status, results, currentTest) {
        const result = {
            data: results[currentTest] || {},
            ingested: false,
            task: currentTest
        };
        const runningTest = {
            type: InstantTest_const_1.InstantTestType.DEVICE_TEST,
            task: currentTest
        };
        Emitter_1.internalEmitter.emit('instant-test:results', {
            runningTest,
            result,
            status
        });
    },
    runningTest(test, options = {}) {
        this.runWebSpeedTest(test.task, options);
    } });
if (window.Cypress) {
    window.DeviceTesting = DeviceTesting;
    if (window.Cypress.setDeviceTesting) {
        window.Cypress.setDeviceTesting(DeviceTesting);
    }
}
exports.default = DeviceTesting;
//# sourceMappingURL=DeviceTesting.js.map